var map = {
	"./vus-cancel.svg": 73,
	"./vus-load.svg": 74
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 72;


//////////////////
// WEBPACK FOOTER
// ./src/styles/common/icons/svg nonrecursive \.svg$
// module id = 72
// module chunks = 0